import globalStyles from 'styles/index';

const defaultStyles = {
    headerCol: {
        ...globalStyles.tableHeaderColumnCSS,
        textAlign: 'center',
        border: '1px solid #eaeaea',
        fontSize: '10px',
        boxSizing: 'border-box'
    },
    tableRow: {
        ...globalStyles.tableRowColumnCSS,
        borderLeft: '1px solid #eaeaea',
        boxSizing: 'border-box'
    },
    borderRight: '1px solid #eaeaea'
}

const styles = {
    ...defaultStyles,
    headerColSm: {
        ...defaultStyles.headerCol,
        width: '4%',
    },
    tableRowSm: {
        ...defaultStyles.tableRow,
        width: '4%',
    },
    error: {
        borderTop: '1px solid salmon',
        borderRight: '1px solid salmon',
        borderBottom: '1px solid salmon',
        borderLeft: '1px solid salmon',
    },
    buttons: {
        style: {
            height: '25px',
            lineHeight: '25px',
            marginTop: '10px',
        }, 
        labelStyle: {
            fontSize: '13px',
        },
    }
};

export default styles;



// WEBPACK FOOTER //
// ./app/components/TcIndex/styles.js